export enum enmStopFreeSale {
    StopSale = 0,
    FreeSale = 1,
}
